import { existingHeaders } from "./utils";
import { getSendOtpCodeLink } from "utils/urls";
import { getAuthUrl } from "utils/env";
import { getMfaRecoveryId } from "utils/mfaSession";
import { MFA_RECOVERY_ID_PARAM } from "constants/mfaAndOtp";

export const otpService = {
  requestOtp,
  requestForgotPasswordOtp,
  requestAccountRecoveryOtp,
  verifyOtp,
};

const requestOptions = {
  credentials: "same-origin",
  headers: existingHeaders,
  method: "POST",
};

async function requestOtp() {
  // If this customer was already sent back to login once, pass the recovery id
  // so a repeat "cookie missing" failure is logged against it.
  const recoveryId = getMfaRecoveryId();
  const query = recoveryId
    ? `?${MFA_RECOVERY_ID_PARAM}=${encodeURIComponent(recoveryId)}`
    : "";
  const response = await fetch(
    getAuthUrl(getSendOtpCodeLink()) + query,
    requestOptions
  );
  // Parse the response body so callers can access customer_info (masked email /
  // mobile) returned by the new split-frontend flow — previously this was
  // provided via the Thymeleaf data-customer-info HTML attribute.
  // Error bodies are parsed too so callers can distinguish specific failures
  // (e.g. "mfa-token-cookie-missing") from generic send errors.
  const body = await response.json().catch(() => ({}));
  // Attach the parsed body to the response so existing `response.ok` checks
  // still work while new code can read `response.customerInfo`.
  response.customerInfo = (response.ok && body && body.customer_info) || null;
  response.errorMessage =
    (!response.ok &&
      body &&
      body.error_response &&
      body.error_response.message) ||
    null;
  response.recoveryId = (!response.ok && body && body.recovery_id) || null;
  return response;
}

function requestForgotPasswordOtp(email, recaptchaToken) {
  return fetch(getAuthUrl("/password/forgotten-password"), {
    ...requestOptions,
    body: JSON.stringify(email, recaptchaToken),
  });
}

function requestAccountRecoveryOtp(email, lastName) {
  return fetch(getAuthUrl("/password/send-otp"), {
    ...requestOptions,
    body: JSON.stringify({ email, lastName }),
  });
}

function verifyOtp(code, email, ioBlackbox) {
  return fetch(getAuthUrl("/password/verify-otp"), {
    ...requestOptions,
    method: "PUT",
    body: JSON.stringify({ code, email, ioBlackbox }),
  });
}
